<template>
  <div id="app" >
    <!-- الشريط الجانبي يظهر فقط إذا كان المستخدم مسجلاً -->
    <!-- <Sidebar 
      v-if="isUserAuthenticated" 
      :user="currentUser" 
      @logout="handleLogout" 
    /> -->
    
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import api from '@/api/api';
//import html2canvas from 'html2canvas';

export default {
  name: "ResultPortal",
  data() {
    return {
      seatNumber: '',
      loading: false,
      result: null,
      error: null,
      viewMode: 'card',
      processingShare: false,
      phone: '',
      subscribing: false
    };
  },
  methods: {
    async getResult() {
      if(!this.seatNumber) return;
      this.loading = true;
      this.error = null;
      this.result = null;

      try {
        const res = await api.get(`/public/result/${this.seatNumber}`);
        this.result = res.data;
      } catch (e) {
        if(e.response && e.response.status === 404) {
            this.error = "رقم الجلوس غير صحيح، يرجى التأكد والمحاولة مرة أخرى.";
        } else {
            this.error = "حدث خطأ في الاتصال بالسيرفر.";
        }
      } finally {
        this.loading = false;
      }
    },

    async subscribeToNotify() {
        if(!this.phone || this.phone.length < 10) return alert("رقم الهاتف غير صحيح");
        this.subscribing = true;
        try {
            await api.post('/public/subscribe-result', {
                seat_number: this.result.student.seat_number,
                phone: this.phone
            });
            alert("تم الاشتراك بنجاح! ستصلك رسالة واتساب.");
            this.phone = '';
        } catch(e) {
            alert("حدث خطأ أثناء الاشتراك.");
        } finally {
            this.subscribing = false;
        }
    },

    getStatusClass(status) {
        if(status === 'pass') return 'bg-success';
        if(status === 'round2') return 'bg-danger';
        return 'bg-warning text-dark';
    },

    getScoreColor(percent) {
        if(percent >= 85) return 'score-excellent';
        if(percent >= 75) return 'score-verygood';
        if(percent >= 65) return 'score-good';
        if(percent >= 50) return 'score-pass';
        return 'score-fail';
    },

    printResult() { window.print(); },

    async shareDesign() {
        this.processingShare = true;
        const element = document.getElementById('certificateNode');
        if (!element) return;
        try {
            const canvas = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
            canvas.toBlob(async (blob) => {
                const file = new File([blob], "result.png", { type: "image/png" });
                if (navigator.share && navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file], title: 'النتيجة' });
                } else {
                    const link = document.createElement('a');
                    link.href = canvas.toDataURL("image/png");
                    link.download = `Result-${this.seatNumber}.png`;
                    link.click();
                }
                this.processingShare = false;
            });
        } catch (error) { this.processingShare = false; }
    },
     printPage() {
         this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;800&display=swap');

.result-page-wrapper {
    font-family: 'Cairo', sans-serif;
    min-height: 100vh;
    background: linear-gradient(135deg, #002147 0%, #0d47a1 100%);
    position: relative;
    overflow-x: hidden;
}

.background-shapes {
    position: absolute;
    width: 100%; height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    z-index: 0;
}

.text-gold { color: #ffd700; }
.title-shadow { text-shadow: 0 4px 10px rgba(0,0,0,0.3); }

/* Card View */
.certificate-card {
    border: 1px solid rgba(0,0,0,0.1);
    background-image: linear-gradient(to bottom right, #fff, #f8f9fa);
}
.status-ribbon { position: absolute; top: 0; left: 0; right: 0; text-transform: uppercase; letter-spacing: 1px; }
.total-score-circle { position: relative; width: 120px; height: 120px; }
.circular-chart { display: block; margin: 0 auto; max-width: 100%; max-height: 100%; }
.circle-bg { fill: none; stroke: #eee; stroke-width: 2.5; }
.circle { fill: none; stroke-width: 2.5; stroke-linecap: round; animation: progress 1s ease-out forwards; }
.score-excellent .circle { stroke: #198754; }
.score-verygood .circle { stroke: #0d6efd; }
.score-good .circle { stroke: #0dcaf0; }
.score-fail .circle { stroke: #dc3545; }
.score-content { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center; line-height: 1; }
@keyframes progress { 0% { stroke-dasharray: 0 100; } }

/* Table View */
.official-sheet {
    border: 3px double #000;
    min-height: 297mm;
    background-color: #fff;
    position: relative;
    font-family: 'Times New Roman', 'Cairo', serif;
}
.watermark-logo {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 300px; height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.05;
    z-index: 0;
    pointer-events: none;
}
.student-info-box { z-index: 1; position: relative; }
.grades-table th { background-color: #f0f0f0; font-weight: 800; border-width: 2px; }
.grades-table td { font-weight: 600; font-size: 15px; }
.total-row { background-color: #f8f9fa; border-top: 3px double #000; font-weight: 900; }
.btn-gold { background-color: #ffd700; border: none; }

/* Print */
@media print {
    .result-page-wrapper { background: white !important; }
    .search-card, .btn, .d-print-none, .background-shapes { display: none !important; }

    #printAreaCard .certificate-card {
        box-shadow: none !important;
        border: 2px solid #000 !important;
        width: 100%; position: absolute; left: 0; top: 0;
    }

    #printAreaTable .official-sheet {
        box-shadow: none !important;
        border: none;
        width: 100%; position: absolute; left: 0; top: 0;
    }

    .badge { border: 1px solid #000; color: black !important; }
    .progress-bar, .bg-dark, .bg-light { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    .text-white { color: black !important; }
    .bg-dark { color: white !important; background-color: black !important; }
    .text-success { color: black !important; font-weight: bold; }
    .text-danger { color: black !important; text-decoration: underline; }
}

.bg-orange-light {
    background-color: #fff3e0;
}
.text-orange {
    color: #e65100;
}
.border-dashed {
    border-style: dashed !important;
}
.extra-small {
    font-size: 0.75rem;
}
.hover-lift:hover {
    transform: translateY(-2px);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.transition-all {
    transition: all 0.3s ease;
}
.icon-pulse-container {
    position: relative;
    z-index: 1;
}
/* تأثير النبض خلف الأيقونة */
.icon-pulse-container::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 50%;
    z-index: -1;
    animation: custom-pulse 2s infinite;
}

@keyframes custom-pulse {
    0% { transform: scale(1); opacity: 0.8; }
    100% { transform: scale(1.6); opacity: 0; }
}

<style scoped>
/* أيقونة الساعة النابضة */
.animate-pulse {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { transform: scale(1); filter: drop-shadow(0 0 0px rgba(255,193,7,0)); }
    50% { transform: scale(1.1); filter: drop-shadow(0 0 15px rgba(255,193,7,0.5)); }
    100% { transform: scale(1); filter: drop-shadow(0 0 0px rgba(255,193,7,0)); }
}

/* شريط المجموع الكلي */
.table-primary {
    background-color: rgba(26, 115, 232, 0.1) !important;
    border-top: 2px solid var(--primary-color);
}

/* الهيدر الخاص بالنتيجة */
.card-header {
    border-bottom: 0;
    position: relative;
}

.card-header::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: rgba(255,255,255,0.2);
}

/* تنسيقات مخصصة للبيان الرسمي */
.official-sheet {
    border: 2px solid #eee;
    font-family: 'Cairo', sans-serif;
}

.custom-table th {
    padding: 12px;
    font-weight: 800;
}

.custom-table td {
    padding: 10px;
}

.bg-primary-subtle { background-color: #e7f1ff; }
.bg-success-subtle { background-color: #e6ffed; }
.bg-danger-subtle { background-color: #fff5f5; }

.info-item {
    transition: all 0.3s ease;
}

@media print {
    .official-sheet {
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
    }
    .d-print-none { display: none !important; }
    body { background-color: white !important; }
    .rounded-4 { border-radius: 0 !important; }
}

/* تحسينات للشاشات الصغيرة */
@media (max-width: 768px) {
    .info-item {
        flex-direction: column;
        align-items: flex-start !important;
    }
    .info-item span {
        min-width: auto !important;
        margin-bottom: 5px;
    }
    .fs-3 { font-size: 1.5rem !important; }
    .fs-4 { font-size: 1.25rem !important; }
}
.fw-extrabold { font-weight: 800; }
.letter-spacing-1 { letter-spacing: 1px; }
.shadow-2xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15); }

.icon-pulse-container {
    position: relative;
    z-index: 1;
}
.icon-pulse-container::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: #0d6efd;
    opacity: 0.1;
    border-radius: 50%;
    z-index: -1;
    animation: custom-pulse 2s infinite;
}

@keyframes custom-pulse {
    0% { transform: scale(1); opacity: 0.3; }
    100% { transform: scale(1.8); opacity: 0; }
}

.hover-lift:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.2) !important;
}

.lh-lg { line-height: 1.8; }

/* ألوان مخصصة للحالات */
.bg-orange-light { background-color: #fff8e1; }
.text-orange { color: #f57c00; }
</style>
